import { useEffect, } from 'react';
import { useSetState, useMountedState, } from 'react-use';
import { useSnackbar, } from 'notistack';
import { v4 as uuidv4, } from 'uuid';
import { updateProfile, } from 'firebase/auth';
import { auth, db, } from '../firebase/config';
import { createUserWithEmailAndPassword, } from 'firebase/auth';
import { collection, doc, setDoc, Timestamp, } from 'firebase/firestore';
import { useApp, } from './useApp';

export const useSignup = () => {
    const [state, setState] = useSetState({
        isPending: false,
        error: null,
    });

    const { loginUser, } = useApp();
    const isMounted = useMountedState();
    const { enqueueSnackbar, } = useSnackbar();

    const snackbarSignupError = (variant, message) => () => {
        enqueueSnackbar(message, { variant });
    };

    const signup = async ({ email, password, displayName, testData, }) => {
        setState({
            isPending: true,
            error: null,
        });

        try {
            const res = await createUserWithEmailAndPassword(auth, email, password);

            if (!res) {
                throw new Error('Не удалось завершить регистрацию');
            }

            await updateProfile(auth.currentUser, { displayName, });

            await setDoc(doc(db, 'userSettings', res.user.uid), {
               mode: 'dark',
            });

            if (testData) {
                const newSetDrinksRef = doc(collection(db, 'sets'));
                const newSetAnimalsRef = doc(collection(db, 'sets'));
                const newSetVegetablesRef = doc(collection(db, 'sets'));
                const newSetColorsRef = doc(collection(db, 'sets'));
                const newFolder1Ref = doc(collection(db, 'folders'));
                const newFolder2Ref = doc(collection(db, 'folders'));

                await setDoc(newSetDrinksRef, {
                    uid: res.user.uid,
                    createdAt: Timestamp.fromDate(new Date()),
                    title: 'Напитки - Тестовый сет карточек',
                    description: 'Тема напитков на английском языке не только важна для изучения, а также увлекательна и приятна',
                    terms: [
                        {
                            id: uuidv4(),
                            eng: 'tea',
                            rus: 'чай',
                        },
                        {
                            id: uuidv4(),
                            eng: 'coffee',
                            rus: 'кофе',
                        },
                        {
                            id: uuidv4(),
                            eng: 'lemonade',
                            rus: 'лимонад',
                        },
                        {
                            id: uuidv4(),
                            eng: 'juice',
                            rus: 'сок',
                        },
                        {
                            id: uuidv4(),
                            eng: 'cocoa',
                            rus: 'какао',
                        },
                    ],
                    modes: {
                        learningCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                        writeCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                    },
                });
                await setDoc(newSetAnimalsRef, {
                    uid: res.user.uid,
                    createdAt: Timestamp.fromDate(new Date()),
                    title: 'Животные - Тестовый сет карточек',
                    description: 'Животный мир бесконечно разнообразен и прекрасен',
                    terms: [
                        {
                            id: uuidv4(),
                            eng: 'muskrat',
                            rus: 'ондатра',
                        },
                        {
                            id: uuidv4(),
                            eng: 'octopus',
                            rus: 'осьминог',
                        },
                        {
                            id: uuidv4(),
                            eng: 'dog',
                            rus: 'собака',
                        },
                        {
                            id: uuidv4(),
                            eng: 'cat',
                            rus: 'кошка',
                        },
                        {
                            id: uuidv4(),
                            eng: 'rat',
                            rus: 'крыса',
                        },
                    ],
                    modes: {
                        learningCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                        writeCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                    },
                });
                await setDoc(newSetVegetablesRef, {
                    uid: res.user.uid,
                    createdAt: Timestamp.fromDate(new Date()),
                    title: 'Названия овощей - Тестовый сет карточек',
                    description: 'Наряду с фруктами, овощи (vegetables) являются важнейшей темой в английском языке на начальном этапе изучения',
                    terms: [
                        {
                            id: uuidv4(),
                            eng: 'beans',
                            rus: 'фасоль',
                        },
                        {
                            id: uuidv4(),
                            eng: 'asparagus',
                            rus: 'спаржа',
                        },
                        {
                            id: uuidv4(),
                            eng: 'beets',
                            rus: 'свекла',
                        },
                        {
                            id: uuidv4(),
                            eng: 'cucumber',
                            rus: 'огурец',
                        },
                        {
                            id: uuidv4(),
                            eng: 'garlic',
                            rus: 'чеснок',
                        },
                        {
                            id: uuidv4(),
                            eng: 'greens',
                            rus: 'зелень',
                        },
                        {
                            id: uuidv4(),
                            eng: 'broccoli',
                            rus: 'брокколи',
                        },
                    ],
                    modes: {
                        learningCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                        writeCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                    },
                });
                await setDoc(newSetColorsRef, {
                    uid: res.user.uid,
                    createdAt: Timestamp.fromDate(new Date()),
                    title: 'Цвета на английском - Тестовый сет карточек',
                    description: 'Названия цветов на английском языке, пожалуй, одна из самых наглядных тем для изучения',
                    terms: [
                        {
                            id: uuidv4(),
                            eng: 'pink',
                            rus: 'розовый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'golden',
                            rus: 'золотой',
                        },
                        {
                            id: uuidv4(),
                            eng: 'lilac',
                            rus: 'лиловый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'magenta',
                            rus: 'пурпурный',
                        },
                        {
                            id: uuidv4(),
                            eng: 'white',
                            rus: 'белый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'brown',
                            rus: 'коричневый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'yellow',
                            rus: 'желтый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'purple',
                            rus: 'сиреневый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'burgundy',
                            rus: 'бордовый',
                        },
                        {
                            id: uuidv4(),
                            eng: 'orange',
                            rus: 'оранжевый',
                        },
                    ],
                    modes: {
                        learningCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                        writeCards: {
                            answer: 'rus',
                            progress: 0,
                            random: false,
                            termsType: 'all',
                        },
                    },
                });

                await setDoc(newFolder1Ref, {
                    uid: res.user.uid,
                    createdAt: Timestamp.fromDate(new Date()),
                    title: 'Необходимо выучить - Тестовая папка',
                    description: 'В данной папке будут храниться сеты карточек, которые нужно выучить как можно скорее',
                });
                await setDoc(newFolder2Ref, {
                    uid: res.user.uid,
                    createdAt: Timestamp.fromDate(new Date()),
                    title: 'Хобби - Тестовая папка',
                    description: 'В данной папке будут храниться сеты карточек, связанные с моими хобби',
                });
            }

            loginUser(res.user);

            if (isMounted()) {
                setState({
                    isPending: false,
                    error: null,
                });
            }
        }
        catch(error) {
            if (isMounted()) {
                setState({
                    isPending: false,
                    error,
                });
            }
        }
    };

    useEffect(() => {
        state.error && snackbarSignupError('error', state.error.message)();
    }, [state.error]);

    return {
        ...state,
        signup,
    };
};